/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  FormFieldType,
  IFormRadioGroup,
  IFormValidatable,
  RequiredValidations,
} from '../typings';
import { BaseFormFieldBuilder } from '.';

type Validations = RequiredValidations<IFormRadioGroup['validations']>;

export class RadioGroupFormFieldBuilder
  extends BaseFormFieldBuilder<IFormRadioGroup>
  implements IFormValidatable<Validations>
{
  // @ts-ignore
  private _type = FormFieldType.RadioGroup as const;
  // @ts-ignore
  private _useShortName?: IFormRadioGroup['useShortName'];
  // @ts-ignore
  private _canAddEntry?: IFormRadioGroup['canAddEntry'];
  // @ts-ignore
  private _options?: IFormRadioGroup['options'];
  private _validations?: Validations;

  constructor() {
    super();
  }

  public useShortName(value: IFormRadioGroup['useShortName']): this {
    this._useShortName = value;
    return this;
  }

  public canAddEntry(value: IFormRadioGroup['canAddEntry']): this {
    this._canAddEntry = value;
    return this;
  }

  public options(value: IFormRadioGroup['options']): this {
    this._options = value;
    return this;
  }

  public validation(value: Validations[number]): this {
    if (this._validations) {
      this._validations.push(value);
    } else {
      this._validations = [value];
    }

    return this;
  }

  public validations(value: Validations): this {
    if (this._validations) {
      this._validations.push(...value);
    } else {
      this._validations = [...value];
    }

    return this;
  }
}
